module.exports = __webpack_public_path__ + "img/mon_64.26f85bee.png";